import type { BaseChartProps } from './ChartFrame';
export type { BaseChartProps } from './ChartFrame';
export interface ChartData {
  name: string;
  value: number;
  color?: string;
}
export interface TimeSeriesData {
  date: string;
  value: number;
}
export interface BarChartProps extends BaseChartProps {
  data: ChartData[];
  dataKey?: string;
  valueKey?: string;
  showGrid?: boolean;
  horizontal?: boolean;
}
export interface PieChartProps extends BaseChartProps {
  data: ChartData[];
  innerRadius?: number;
  outerRadius?: number;
}
export interface LineChartProps extends BaseChartProps {
  data: TimeSeriesData[];
  dataKey?: string;
  valueKey?: string;
  smooth?: boolean;
  fill?: boolean;
}
export interface AreaChartProps extends BaseChartProps {
  data: TimeSeriesData[];
  dataKey?: string;
  valueKey?: string;
  fillOpacity?: number;
}

export const calendarTick = (value: string, context: { location: string }): string =>
  context.location === 'tooltip' || !/^\d{4}-\d{2}-\d{2}$/.test(value) ? value : value.slice(5).replace('-', '/');
